export default __webpack_public_path__ + "static/en_badge_web_generic-c410aab2e1110041d214b3767de858c7.png";